import { render, staticRenderFns } from "./v-dalog.vue?vue&type=template&id=607984be&scoped=true&"
import script from "./v-dalog.vue?vue&type=script&lang=js&"
export * from "./v-dalog.vue?vue&type=script&lang=js&"
import style0 from "./v-dalog.vue?vue&type=style&index=0&id=607984be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607984be",
  null
  
)

export default component.exports